import * as tslib_1 from "tslib";
import { MatDialog } from '@angular/material/dialog';
import { ABaseComponent } from 'src/app/shared/modules/ui/components/abstract/a-base.component';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { UiService } from '../../../../shared/modules/ui/services/ui.service';
import { LoggerService, VehicleService } from '../../../../shared/sdk';
import notify from 'devextreme/ui/notify';
export class VehicleDetailsTabInvoicesComponent extends ABaseComponent {
    constructor(logger, ui, dss, dialog) {
        super(logger);
        this.logger = logger;
        this.ui = ui;
        this.dss = dss;
        this.dialog = dialog;
    }
    set vehicleService(v) {
        this._vehicleService = v;
        this.changeHandle();
    }
    get vehicleService() {
        return this._vehicleService;
    }
    changeHandle() { }
    onInvoiceInserting(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                event.data.id = event.data.__KEY__;
                event.data.createdAt = new Date();
                event.data.updatedAt = new Date();
                let { invoices } = this.vehicleService;
                invoices = [Object.assign({}, event.data, { __KEY__: undefined }), ...this.vehicleService.invoices];
                this.vehicleService.invoices = invoices; // Update the local state with predicted data
                // Call the API to add the new invoice
                const updatedVehicleService = yield this.dss
                    .getApi(VehicleService)
                    .mySaveWithRelated(this.vehicleService.id, { invoices })
                    .toPromise();
                // Update the local state with the response
                this.vehicleService.invoices = updatedVehicleService.invoices;
            }
            catch (error) {
                notify('Error inserting invoice', 'error', 3000);
                console.error('Error inserting invoice:', error);
                event.cancel = true;
            }
        });
    }
    onInvoiceUpdating(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const { invoices } = this.vehicleService;
                const index = invoices.findIndex((inv) => inv.id === event.key.id);
                if (index !== -1) {
                    invoices[index] = Object.assign({}, invoices[index], event.newData, { updatedAt: new Date() });
                    const { invoices: updatedInvoices } = yield this.dss
                        .getApi(VehicleService)
                        .mySaveWithRelated(this.vehicleService.id, { invoices })
                        .toPromise();
                    this.vehicleService.invoices = updatedInvoices;
                }
            }
            catch (error) {
                notify('Error updating invoice', 'error', 3000);
                console.error('Error updating invoice:', error);
                event.cancel = true;
            }
        });
    }
    onInvoiceRemoving(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { invoices } = this.vehicleService;
            const index = invoices.findIndex((inv) => inv.id === event.key.id);
            if (index !== -1) {
                invoices.splice(index, 1);
                const { invoices: updatedInvoices } = yield this.dss
                    .getApi(VehicleService)
                    .mySaveWithRelated(this.vehicleService.id, { invoices })
                    .toPromise();
                this.vehicleService.invoices = updatedInvoices;
            }
        });
    }
}
